import { DropdownWithSearch } from "InnoUI/innoinput";
import { selectTimeframe } from "utils/optionData/utils";

const SelectTimeframeDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
  disabledDropdown,
  placeholder,
}) => {
  const Options = selectTimeframe.map((data) => ({
    id: data.id,
    label: data.label,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = Options.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      options={Options}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="32%"
      dropdowType={name}
      placeholder={placeholder}
      height="32px"
      disabledDropdown={disabledDropdown}
    />
  );
};

export default SelectTimeframeDropdown;
